import React, {useContext, useEffect} from 'react';
import FilterGroupList from "../components/FilterGroup/FilterGroupList";
import VehicleList from "../components/VehicleList/VehicleList";
import LoadingContainer from "../../components/LoadinContainer/LoadingContainer";
import { useStyleContext } from '../../../customHooks/useStyleContext';
import { useSearch } from '../SearchProvider';
import AlertDialog from '../../components/AlertDialog/AlertDialog';

const SearchResult = ({filterGroups,selectedFilterGroups,vehicles, handleFilterSelect,setStepHeader, onVehicleSelect, loading, searchParameters,agencyCount,startAgency,endAgency, suggestVehicles, isSearchStale }) => {
    const styleContext = useStyleContext();

    const { searchDateErrors, alertDialogOpen, toggleAlertDialog } = useSearch();

    useEffect(() => {
        setStepHeader(0)
    }, [])
    return (
        <div>
            <div>
                {filterGroups?.length > 0 && (
                    <div className={"mb-3 d-none d-lg-block"}>
                        <FilterGroupList filterGroups={filterGroups} selectedFilterGroup={selectedFilterGroups} onSelect={handleFilterSelect}/>
                    </div>
                )}

                <LoadingContainer loading={loading && !vehicles?.length } title={"recherche en cours..."} color={styleContext?.colors?.["c-main"] ?? 'white'}>

                    <VehicleList
                        vehicles={vehicles}
                        onVehicleSelect={onVehicleSelect}
                        searchParameters={searchParameters}
                        loading={loading}
                        agencyCount={agencyCount}
                        disableAgencies={styleContext?.app_config?.disable_agency_choice ?? false}
                        startAgency={startAgency}
                        endAgency={endAgency}
                        suggestVehicles={suggestVehicles}
                        isSearchStale={isSearchStale}
                    />
                </LoadingContainer>

                <AlertDialog
                    isOpen={alertDialogOpen}
                    handleClose={toggleAlertDialog}
                >
                    <div>
                        {searchDateErrors?.map((item, index) => {
                            return <p key={`parameter-error-item-${index}`} className={"medium fs18"}>{item}</p>
                        })}
                    </div>
                </AlertDialog>
            </div>
        </div>
    );
};

export default SearchResult;
